// extracted by mini-css-extract-plugin
module.exports = {"upi-badge":"upiBadge_upi-badge__oAyys","label":"upiBadge_label__8nU78","logo":"upiBadge_logo__PVGLG"};